// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"86":"e8d14073","166":"6b3093b3","787":"f8f1f2a9"}[chunkId] + ".chunk.js";
};